import { FaqList } from '@/components/common/FaqList'
import { useUiLang } from '@/i18n'
import { guideFor } from '../guideMessages'

/** Вопросы гайда подключения MCP. */
export const Faq = () => <FaqList items={guideFor(useUiLang()).faq} />
